(() => {
  if (customElements.get('hh-patenlied-option')) return;
  class PatenliedOption extends HTMLElement {
    static choices = new Map();
    connectedCallback() {
      this.checkbox = this.querySelector('[data-song-choice]');
      this.checkbox.disabled = false;
      if (!this.hasAttribute('data-designer')) this.checkbox.checked = PatenliedOption.choices.get(this.dataset.productId) === true;
      this.onChange ||= () => {
        if (!this.hasAttribute('data-designer')) PatenliedOption.choices.set(this.dataset.productId, this.checkbox.checked);
        this.syncForm();
        this.dispatchEvent(new CustomEvent('hh:patenlied-change', { bubbles: true }));
      };
      this.checkbox.addEventListener('change', this.onChange);
      this.mirrors = [];
      if (!this.hasAttribute('data-designer')) {
        const scope = this.closest('.shopify-section');
        for (const preview of scope?.querySelectorAll('[data-hh-patenlied="hoerprobe-45s"]') || []) {
          const label = this.querySelector('.hh-patenlied-label').cloneNode(true);
          label.dataset.hhSongMirror = this.dataset.productId;
          const input = label.querySelector('input');
          input.removeAttribute('form');
          input.removeAttribute('id');
          input.addEventListener('change', () => { this.checkbox.checked = input.checked; this.onChange(); });
          preview.querySelector('audio')?.after(label);
          this.mirrors.push(label);
        }
      }
      this.syncForm();
    }
    disconnectedCallback() { this.checkbox?.removeEventListener('change', this.onChange); this.mirrors?.forEach(label => label.remove()); }
    syncForm() { (this.checkbox?.form || this.closest('form'))?.toggleAttribute('data-hh-song-selected', this.selected); this.mirrors?.forEach(label => { label.querySelector('input').checked = this.checkbox.checked; }); }
    get selected() { return !this.hidden && !this.checkbox?.disabled && this.checkbox?.checked === true; }
    cartBody(original) {
      if (!this.selected) return original;
      const body = new FormData();
      for (const [key, value] of original.entries()) {
        const itemField = key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties[');
        const name = key.startsWith('properties[') ? 'items[0][properties]' + key.slice(10) : itemField ? 'items[0][' + key + ']' : key;
        if (value instanceof File) body.append(name, value, value.name);
        else body.append(name, value);
      }
      const group = crypto.randomUUID();
      body.append('items[0][properties][_HH_Liedgruppe]', group);
      body.append('items[1][id]', this.dataset.variantId);
      body.append('items[1][quantity]', original.get('quantity') || '1');
      body.append('items[1][parent_id]', original.get('id'));
      body.append('items[1][properties][Lied]', 'Vertrauen und Dank');
      body.append('items[1][properties][_HH_Liedgruppe]', group);
      return body;
    }
  }
  customElements.define('hh-patenlied-option', PatenliedOption);
})();
